$(function () {
  // The API base comes from the host table in partials/base_js.hbs, which is loaded in the
  // <head> of every root layout and is therefore always defined by the time this runs.
  //
  // It replaces a conditional chain that tested `hostname.includes('www.upmarket')` first, so
  // any host it did not recognise fell through to the DEV default. That silently pointed
  // PRODUCTION marketing pages at api.dev.upmarket.co on the global.* hosts added by UP-279 --
  // dev data rendered on a prod page, with nothing failing loudly. The chain had already been
  // patched twice as environments were added, which is why this is a table lookup now.
  const baseUrl =
    (window.UPMARKET_ENV && window.UPMARKET_ENV.api) ||
    'https://api.dev.upmarket.co';

  const instance = axios.create({baseURL: baseUrl});

  instance.interceptors.request.use(
    (config) => {
      config.headers.language = localStorage.getItem('language');
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response) => {
      return response.data || response;
    },
    async (error) => {
      return Promise.reject(error.response);
    },
  );

  window.$http = instance;
});
